import { TranslationDict } from "../types";

export const frOpbouw: TranslationDict = {
  woning: "Maison",
  ruimtes: "Pièces",
  uitgangen: "Sorties",
  ingangen: "Entrées",
  aantal: "Quantité",
  ruimte: "Pièce",
  uitgang: "Sortie",
  maakNaamLeeg: "Effacer le nom",
  geefNaamRuimte: "Donnez un nom à la pièce:",
  voegRuimteToe: "Ajouter une pièce",
  geenRuimteGekozen: "Aucune pièce sélectionnée.",
  moduleBestaatNiet: "Ce module n'existe pas.",
  kast: "Armoire",
  kasten: "Armoires",
  voegKastToe: "Ajouter une armoire",
  naamKast: "Nom de l'armoire:",
  naamCtd: "Nom du CTD:",
  naamCtdTip: "Il est préférable de choisir un nom unique pour éviter toute confusion entre les CTD.",
  controllers: "Contrôleurs",
  voegCtdToe: "Ajouter un CTD",
  offerte: "Offre",
  saOfferte: "Offre SA",
  info: "Info",
  indienst: "Mise en service",
  voegIndienstToe: "Ajouter mise en service",
  totaalprijs: "Prix total",
  module: "Module",
  prijs: "Prix",
  totaal: "Total",
  vrije: "Libre",
  nietInSa: "Les modules suivants ne sont pas disponibles en version Stand Alone:",
  dmx1: "Dimmer",
  dmx6: "RGB",
  dmx8: "RGBW",
  dmx4: "WwKw",
  qdmAddressType: "Type d'adresse",
  qdmIndividual: "Adresse individuelle",
  qdmGroup: "Adresse de groupe",
  qdmFixtureCount: "Nombre d'appareils dans le groupe",
  aantalMods: "Nombre de modules",
  aantalAdressen: "Nombre d'adresses",
  busconsumtion: "Consommation du bus",
  typeUitvoering: "Type de finition",
  errorOffSave: "Pour générer une offre, votre projet doit d'abord être enregistré.",
  errFullSa: "Veuillez choisir FullOfferte ou SaOfferte..",
  errGenOff: "Une erreur s'est produite lors de la génération de l'offre.",
  errGenOverview: "Pour générer un aperçu, votre projet doit d'abord être enregistré.",
  };
